module.exports = __webpack_public_path__ + "img/givefdbck.5a61192b.svg";